import React, { useState, useEffect } from "react";
import {
  createWithdrawPayment,
  uploadFile,
  uploadMerchand,
} from "../../DAL/create";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  TextField,
  MenuItem,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
import SVGAAnimation from "../../Components/SVGAAnimation";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchCategoriesList,
  fetchProductDetail,
  GetProductDetail,
} from "../../DAL/fetch";
import { fileUrl } from "../../Config/Config";
import {
  updateSingleMerchandData,
  UpdateWithdrawPayment,
} from "../../DAL/update";
import { enqueueSnackbar } from "notistack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const globalMethods = ["bank", "usdt", "binance", "epay"];

const localMethodsByCountry = {
  India: ["Paytm", "PhonePe"],
  Pakistan: ["easypaisa", "jazzcash"],
  USA: ["Venmo", "CashApp"],
  // add more as needed
};

const countries = ["India", "Pakistan", "USA", "UAE", "UK"];

function AddWithdrawPayment() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [fileName, setFileName] = useState("");
  const [file2, setFile2] = useState(null);
  const [fileName2, setFileName2] = useState("");
  const [fileUploaded1, setFileUploaded1] = useState(false);
  const [fileUploaded2, setFileUploaded2] = useState(false);
  const [fileURL1, setFileURL1] = useState("");
  const [fileURL2, setFileURL2] = useState("");
  const [filePreview, setFilePreview] = useState(null);
  const [filePreview2, setFilePreview2] = useState(null);
  const [inputs, setInputs] = useState({
    name: "",
    feePercentage: "",
    arrivalInHours: "",
    type: "",
    country: "",
    pictureId: "",
  });
  const [type, setType] = useState("add");
  const [types, setTypes] = useState(false);
  const [message, setMessage] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const getAvailableTypes = (country) => {
    return [...globalMethods, ...(localMethodsByCountry[country] || [])];
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      setFile(selectedFile); // this is the binary file object
    }
  };
  const handleFileSubmit1 = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage(true);
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    setLoading(true);
    try {
      const imagedata = await uploadFile(formData);
      setFileURL1(imagedata.data.id);
      setFileUploaded1(true);
      enqueueSnackbar("File uploaded successfully!", {
        variant: "success",
      });
    } catch (error) {
      console.error("Error uploading file:", error);
      enqueueSnackbar("Failed to upload file. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (inputs?.name == "") {
      setTypes(true);
      return;
    }
    if (!inputs?.type) {
      setTypes(true);
      return;
    }
    if (inputs?.country == "") {
      setTypes(true);
      return;
    }
    if (inputs?.feePercentage == "") {
      setTypes(true);
      return;
    }
    if (!inputs?.arrivalInHours) {
      setTypes(true);
      return;
    }

    const formData = new FormData();
    formData.append("name", inputs?.name);
    formData.append("country", inputs?.country);
    formData.append("type", inputs?.type);
    formData.append("feePercentage", inputs?.feePercentage);
    formData.append("arrivalInHours", inputs?.arrivalInHours);
    formData.append("pictureId", fileURL1);

    setLoading(true);
    try {
      const resp =
        type == "add"
          ? await createWithdrawPayment(formData)
          : await UpdateWithdrawPayment(id, formData);
      if (resp?.statusCode == 400) {
        setMessage(true);
      } else if (resp?.data?.statusCode == 201) {
        enqueueSnackbar(
          type == "add"
            ? "Withdraw Payment added successfully"
            : "Withdraw Payment updated successfully",
          { variant: "success" }
        );
        navigate("/withdraw-list");
      } else {
        enqueueSnackbar(resp?.message, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Failed to upload Withdraw Payment. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const labelStyles = {
    color: "",
    "&.Mui-focused": {
      color: "#8F29D0",
    },
  };
  const inputStyles = {
    marginBottom: 2,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#8F29D0",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8F29D0",
      },
    },
  };

  return (
    <Box>
      <ArrowBackIcon
        sx={{ cursor: "pointer", margin: "20px" }}
        onClick={() => navigate(-1)}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          alignItems: "center",
          maxWidth: 400,
          margin: "auto",
          mt: 4,
        }}
      >
        <Typography variant="h6">
          {type == "add"
            ? "Create New Withdraw Payment"
            : "Update Withdraw Payment"}
        </Typography>
        <TextField
          select
          fullWidth
          required
          label="Country"
          name="country"
          variant="outlined"
          value={inputs?.country}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
        >
          {countries.map((country) => (
            <MenuItem key={country} value={country}>
              {country}
            </MenuItem>
          ))}
        </TextField>
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types === true && inputs?.country === "" && "Country is Required"}
        </FormHelperText>

        <TextField
          select
          fullWidth
          required
          name="type"
          label="Type"
          variant="outlined"
          value={inputs?.type}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
        >
          {getAvailableTypes(inputs?.country).map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types === true && inputs?.type === "" && "Type is Required"}
        </FormHelperText>

        <TextField
          fullWidth
          required
          name="name"
          label="Name"
          variant="outlined"
          value={inputs?.name}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
        />
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types == true && inputs?.name == "" && "Name is Required"}
        </FormHelperText>
        <TextField
          fullWidth
          required
          label="Fee Percentage"
          name="feePercentage"
          variant="outlined"
          type="number"
          value={inputs?.feePercentage}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
        />
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types == true && inputs?.name == "" && "Fee percentage is Required"}
        </FormHelperText>
        <TextField
          fullWidth
          required
          label="Arrival In Hours"
          variant="outlined"
          name="arrivalInHours"
          type="number"
          value={inputs?.arrivalInHours}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
          inputProps={{ min: 0 }}
        />
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types == true &&
            inputs?.arrivalInHours == "" &&
            "Arrival is Required"}
        </FormHelperText>

        <Typography variant="h6" sx={{ mt: 2 }}>
          Upload Image
        </Typography>
        <Box sx={{ width: "100%", display: "flex", gap: 2 }}>
          <input type="file" accept="image/*" onChange={handleFileChange} />
          <Button
            variant="contained"
            color={fileUploaded1 ? "success" : "primary"}
            onClick={handleFileSubmit1}
            disabled={loading || !file}
            sx={{ textTransform: "none" }}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : fileUploaded1 ? (
              "Uploaded"
            ) : (
              "Upload"
            )}
          </Button>
        </Box>

        {filePreview && (
          <Box sx={{ mt: 2 }}>
            <img
              src={filePreview}
              alt="Preview"
              style={{ maxWidth: "100%", maxHeight: "200px" }}
            />
          </Box>
        )}
        <Button
          variant="contained"
          className="gradientButton"
          onClick={handleSubmit}
          fullWidth
          sx={{ marginBottom: "20px", textTransform: "none" }}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
}

export default AddWithdrawPayment;
